import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import {
  listAll,
  createData,
  updateData,
  removeData
} from "../../services/Template";
import {
  Types,
  listTemplatesSuccess
} from "../reducers/Template";

import {
  componentLoading,
  buttonLoading,
  toggleModal
} from "../actions/loading";
import { notificationMessage } from "../reducers/FeedbackMessage";

function* loadTemplatesForCurrentScope() {
  const companyId = yield select(state => state.filter.companyId);
  return yield call(listAll, companyId);
}

export function* listSaga() {
  yield takeLatest(Types.LIST_TEMPLATE, function* list() {
    try {
      yield put(componentLoading(true));

      const roles = yield call(loadTemplatesForCurrentScope);

      yield put(componentLoading(false));
      yield put(listTemplatesSuccess(roles));
    } catch (error) {
      yield put(componentLoading(false));
      yield put(
        notificationMessage("notifications.template.list.error", "error")
      );
    }
  });
}

export function* listTemplatesSaga() {
  yield takeLatest(Types.LIST_TEMPLATES_PAGE, function* listAllTemplates() {
    try {
      const templates = yield call(loadTemplatesForCurrentScope);
      yield put(listTemplatesSuccess(templates));
    } catch (error) {
      yield put(
        notificationMessage("notifications.template.list.error", "error")
      );
    }
  });
}

export function* createSaga() {
  yield takeLatest(Types.CREATE_TEMPLATE, function*(payload) {
    try {
      yield put(buttonLoading(true));

      yield call(createData, payload);

      yield put(buttonLoading(false));
      yield put(toggleModal(false));

      const roles = yield call(loadTemplatesForCurrentScope);
      yield put(listTemplatesSuccess(roles));
    } catch (error) {
      yield put(buttonLoading(false));
      yield put(toggleModal(false));

      yield put(
        notificationMessage("notifications.template.create.error", "error")
      );
    }
  });
}

export function* updateSaga() {
  yield takeLatest(Types.UPDATE_TEMPLATE, function* update({ payload }) {
    try {
      yield put(buttonLoading(true));

      yield call(updateData, payload);

      yield put(buttonLoading(false));
      yield put(toggleModal(false));

      const roles = yield call(loadTemplatesForCurrentScope);
      yield put(listTemplatesSuccess(roles));
    } catch (error) {
      yield put(buttonLoading(false));
      yield put(toggleModal(false));

      yield put(
        notificationMessage("notifications.template.update.error", "error")
      );
    }
  });
}

export function* deleteSaga() {
  yield takeLatest(Types.DELETE_TEMPLATE, function* remove({ payload }) {
    try {
      yield put(buttonLoading(true));

      yield call(removeData, payload);

      yield put(buttonLoading(false));
      yield put(toggleModal(false));

      const roles = yield call(loadTemplatesForCurrentScope);
      yield put(listTemplatesSuccess(roles));
    } catch (error) {
      yield put(buttonLoading(false));
      yield put(toggleModal(false));

      yield put(
        notificationMessage("notifications.template.delete.error", "error")
      );
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(listSaga),
    fork(listTemplatesSaga),
    fork(createSaga),
    fork(updateSaga),
    fork(deleteSaga)
  ]);
}
